import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { ReactActionDialogOptions } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

export type DialogBodyProps = {
    labelValue: string;
    labelCategory: string;
    labelDescription: string;
    visibility: boolean;
}

type DialogState = {
}

type ActionDialogOptions = ReactActionDialogOptions<DialogBodyProps, DialogState, unknown>;

function mapVisibilityToString(visibility: boolean) {
    if(visibility) {
        return Messages.labelVisibilityStandard();
    } else {
        return Messages.labelHighVisibility();
    }
}

function DialogBody({labelValue, labelDescription, visibility}: DialogBodyProps): React.ReactElement {

    return (
        <>
            <div>
              {Messages.revertToDefaultLabelWarning()}
            </div>
            <div style={{display: 'flex', paddingTop: '10px'}}>
                <div style={{fontWeight: 'bold', marginRight: '5px'}}>{Messages.revertToDefaultLabel_action_value()}</div>
                <>{'\"' + labelValue + '\"'}</>
            </div>
            <div style={{display: 'flex', paddingTop: '10px'}}>
                <div style={{fontWeight: 'bold', marginRight: '5px'}}>{Messages.revertToDefaultLabel_action_visibility()}</div>
                <>{mapVisibilityToString(visibility)}</>
            </div>
            <div style={{display: 'flex', paddingTop: '10px'}}>
                <div style={{fontWeight: 'bold', marginRight: '5px'}}>{Messages.revertToDefaultLabel_action_description()} </div>
                <>{'\"' + labelDescription + '\"'}</>
            </div>
            <div style={{paddingTop: '10px'}}>
                {Messages.revertToDefaultLabel_action_warning()}
            </div>
        </>
    );
  }

export function getActionDialogOptions(args: {
    doAction: (dialogBodyProps: DialogBodyProps) => Promise<unknown>;
    initialBodyProps: DialogBodyProps;
}): ActionDialogOptions {
    const { doAction, initialBodyProps } = args;

    return {
      title: Messages.revertToDefaultLabel_action_title(),
      bodyComponent: DialogBody,
      initialDialogState: {},
      initialBodyProps,
      actionName: 'Revert',
      action: (dialogProps, __, ___) => doAction(dialogProps),
      dismissDialogOnActionFailed: true,
      dialogWidth: TabDialogWidth.width400px,
      isActionDelete: true
    };
  }